// extracted by mini-css-extract-plugin
export default {"root":"root___gwX2N","body":"body___GB6SP","intro":"intro___sPMvD","icon":"icon___vD64W","footer":"footer___lFviQ","sdk":"sdk___KNEKb"};